var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { openApp } from '@funny/cross-platform';
import { env, getGlobalParams, extractExistUrlParams } from '@funny/env';
import { post } from '@funny/request';
import { track } from '@funny/track';
import { Toast } from '@funny/widgets';
import { bridge } from '@funny/bridge';
var toast = new Toast();
var Goto = /** @class */ (function () {
    function Goto() {
    }
    /**
     * 通用跳转方法
     * @param url 跳转的地址
     * @param params 附加的参数
     * @param omitParams 需要过滤的参数
     */
    Goto.prototype.redirectTo = function (url, params, omitParams) {
        if (params === void 0) { params = {}; }
        if (omitParams === void 0) { omitParams = []; }
        // 为什么要多加一个&，因为唱吧app里面有各种奇奇怪怪的问题
        window.location.href =
            url +
                '?&' +
                extractExistUrlParams({
                    params: params,
                    omitParams: omitParams,
                });
    };
    /**
     * 端内跳转
     * @param url 跳转的地址
     * @param params 附加的参数
     * @param omitParams 需要过滤的参数
     */
    Goto.prototype.innerRedirectTo = function (url, params, omitParams) {
        if (params === void 0) { params = {}; }
        if (omitParams === void 0) { omitParams = []; }
        return __awaiter(this, void 0, void 0, function () {
            var cbGlobalParam, authParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getGlobalParams()];
                    case 1:
                        cbGlobalParam = _a.sent();
                        authParams = {
                            token: cbGlobalParam.token,
                            curuserid: cbGlobalParam.userId,
                        };
                        this.redirectTo(url, Object.assign(params, authParams), omitParams);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 关注主播，此方法会修改您传入的anchor信息
     * @param anchor 主播信息
     * @returns
     */
    Goto.prototype.followAnchor = function (anchor, autoTrack) {
        var _a;
        if (autoTrack === void 0) { autoTrack = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _b, userId, token, followId, cbFollowId, isFollow, results, params, url, res;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = env.userInfo, userId = _b.userId, token = _b.token;
                        followId = anchor.userid || anchor.user_id;
                        cbFollowId = anchor.cbuserid || anchor.cb_user_id || anchor.changba_user_id || anchor.changbauserid || 0;
                        isFollow = (_a = anchor.is_follow) !== null && _a !== void 0 ? _a : anchor.isfollow;
                        results = false;
                        // 关注自己，url解析出来是字符串，后端返回的不一定是，就不用严格判等了
                        // eslint-disable-next-line eqeqeq
                        if (followId == userId || cbFollowId == userId) {
                            toast.show('您时时刻刻都在关注着你自己个儿哦~~');
                            return [2 /*return*/, results];
                        }
                        // 已关注
                        if (isFollow === 1) {
                            return [2 /*return*/, true];
                        }
                        params = {
                            ac: 'follow',
                            curuserid: userId,
                            followid: followId,
                            cbfollowid: cbFollowId,
                            token: token,
                        };
                        // eslint-disable-next-line eqeqeq
                        if (userId == '0') {
                            toast.show('请登录火星后再尝试');
                            url = "xiaochangmars://?ac=userinfo&uid=".concat(followId);
                            this.jumpToApp(url);
                            return [2 /*return*/, results];
                        }
                        // 自动发送埋点
                        if (autoTrack) {
                            track('follow', {
                                follow_page: document.title,
                                enter_source: document.title,
                                business_line: env.browser.isMars ? 'mars' : 'live',
                                anchor_id: env.browser.isMars ? followId : cbFollowId,
                                operation_type: '关注',
                            });
                        }
                        return [4 /*yield*/, post({
                                url: 'https://mars.changba.com/api/mars_follow_api.php',
                                data: params,
                                showLoading: false,
                                autoTokenWithUserId: false,
                                ignoreBaseURL: true,
                            })];
                    case 1:
                        res = _c.sent();
                        if (res.code === 0) {
                            if (typeof anchor.is_follow !== 'undefined') {
                                anchor.is_follow = 1;
                            }
                            else {
                                anchor.isfollow = 1;
                            }
                            results = true;
                        }
                        else {
                            toast.show(res.msg);
                        }
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * 取消关注主播，此方法会修改您传入的anchor信息
     * @param anchor 主播信息
     * @returns
     */
    Goto.prototype.unFollowAnchor = function (anchor, autoTrack) {
        var _a;
        if (autoTrack === void 0) { autoTrack = true; }
        return __awaiter(this, void 0, void 0, function () {
            var _b, userId, token, followId, cbFollowId, isFollow, results, params, url, res;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = env.userInfo, userId = _b.userId, token = _b.token;
                        followId = anchor.userid || anchor.user_id;
                        cbFollowId = anchor.cbuserid || anchor.cb_user_id || anchor.changba_user_id || anchor.changbauserid || 0;
                        isFollow = (_a = anchor.is_follow) !== null && _a !== void 0 ? _a : anchor.isfollow;
                        results = false;
                        // 已取消关注
                        if (isFollow === 0) {
                            return [2 /*return*/, true];
                        }
                        params = {
                            ac: 'unfollow',
                            curuserid: userId,
                            followid: followId,
                            cbfollowid: cbFollowId,
                            token: token,
                        };
                        // eslint-disable-next-line eqeqeq
                        if (userId == '0') {
                            toast.show('请登录火星后再尝试');
                            url = "xiaochangmars://?ac=userinfo&uid=".concat(followId);
                            this.jumpToApp(url);
                            return [2 /*return*/, results];
                        }
                        // 自动发送埋点
                        if (autoTrack) {
                            track('follow', {
                                follow_page: document.title,
                                enter_source: document.title,
                                business_line: env.browser.isMars ? 'mars' : 'live',
                                anchor_id: env.browser.isMars ? followId : cbFollowId,
                                operation_type: '取关',
                            });
                        }
                        return [4 /*yield*/, post({
                                url: 'https://mars.changba.com/api/mars_follow_api.php',
                                data: params,
                                showLoading: false,
                                autoTokenWithUserId: false,
                                ignoreBaseURL: true,
                            })];
                    case 1:
                        res = _c.sent();
                        if (res && res.code === 0) {
                            if (typeof anchor.isfollow !== 'undefined') {
                                anchor.isfollow = 0;
                            }
                            else {
                                anchor.is_follow = 0;
                            }
                            results = true;
                        }
                        else {
                            toast.show(res.msg);
                        }
                        return [2 /*return*/, results];
                }
            });
        });
    };
    /**
     * 跳转直播间，针对火星使用
     * @param user 用户信息
     * @param config 跳转配置
     * @returns
     */
    Goto.prototype.livePage = function (user, config) {
        var _a;
        if (config === void 0) { config = { autoOpenGiftBag: true, autoTrack: true, closeBeforePage: true }; }
        // 跳转直播间，如果未开播跳个人主页
        var userId = Number.parseInt((_a = user.userid) !== null && _a !== void 0 ? _a : user.user_id, 10) || 0;
        var cbUserId = user.cbuserid || user.cb_user_id || user.changba_user_id || user.changbauserid || 0;
        var liveType = user.livetype || 1;
        var sessionid = user.sessionid || 0;
        var category = [0, 1].includes(liveType) ? 2 : 3;
        var autoOpenGiftBag = config.autoOpenGiftBag, autoTrack = config.autoTrack;
        var autoFlag = autoOpenGiftBag ? 1 : 0;
        if (env.browser.isMars) {
            if (userId <= 0 || Number.isNaN(userId)) {
                return;
            }
            // 未直播，跳个人主页
            if (sessionid === 0) {
                bridge.openPage('xiaochangmars://?ac=userinfo&uid=' + userId, config.closeBeforePage);
            }
            else {
                // 自动发送埋点
                if (autoTrack) {
                    track('enter_studio_live', {
                        enter_source: document.title,
                        business_line: env.browser.isMars ? 'mars' : 'ktv',
                        anchor_id: userId,
                    });
                }
                bridge.openPage("xiaochangmars://?ac=live&uid=".concat(userId, "&sid=").concat(sessionid, "&livetype=").concat(liveType, "&category=").concat(category, "&autoOpenGiftBasket=").concat(autoFlag), config.closeBeforePage);
            }
            return;
        }
        if (env.browser.isChangba) {
            // 先判断是否绑定了唱吧ID
            if (cbUserId === 0 || cbUserId === 'false') {
                toast.show('该用户为火星直播用户，暂时未关联唱吧号');
                return;
            }
            // 未直播跳个人主页
            if (sessionid === 0) {
                bridge.openPage('changba://?ac=personalpage&userid=' + cbUserId, config.closeBeforePage);
            }
            else {
                // 自动发送埋点
                if (autoTrack) {
                    track('enter_studio_live', {
                        enter_source: document.title,
                        business_line: env.browser.isMars ? 'mars' : 'ktv',
                        anchor_id: cbUserId,
                    });
                }
                bridge.openPage("changba://?ac=live&uid=".concat(cbUserId, "&sid=").concat(sessionid, "&livetype=").concat(liveType, "&category=").concat(category, "&backtolist=1&autoOpenGiftBasket=").concat(autoFlag), config.closeBeforePage);
            }
            return;
        }
        // 跳转app
        var tempUrl = window.location.href.split('#');
        // 如果是火星活动，则打开的时候默认打开火星app
        var appType = typeof MARS !== 'undefined' ? 'mars' : 'cb';
        this.jumpToApp(tempUrl[0], '', appType);
    };
    /**
     * 拉起app，并打开至app的某个页面，如果app没有安装，则跳转到对应类型的app下载页
     * @param targetUrl 目标地址
     * @param downloadUrl 下载地址
     * @param appType app类型
     */
    Goto.prototype.jumpToApp = function (targetUrl, downloadUrl, appType) {
        if (appType === void 0) { appType = 'cb'; }
        if (!targetUrl) {
            targetUrl = appType === 'cb' ? 'changba://?ac=hottest' : 'xiaochangmars://?ac=home&index=1';
        }
        if (!downloadUrl) {
            downloadUrl =
                appType === 'cb' ? 'https://changba.com/d?from=home' : 'https://mars.changba.com/download/mars_download.php';
        }
        // 尝试打开App
        if (!env.browser.isChangba && !env.browser.isMars) {
            openApp({
                targetUrl: targetUrl,
                downloadUrl: downloadUrl,
                appType: appType,
            });
        }
    };
    /**
     * 跳转用户详情，主要针对火星使用
     * @param user 用户信息
     * @returns
     */
    Goto.prototype.goUserPage = function (user, closeBeforePage) {
        var _a;
        if (closeBeforePage === void 0) { closeBeforePage = true; }
        // 跳用户个人主页
        var userId = Number.parseInt((_a = user.userid) !== null && _a !== void 0 ? _a : user.user_id, 10) || 0;
        var cbUserId = user.changbauserid || user.cb_user_id || user.changba_user_id || user.cbuserid || 0;
        if (env.browser.isMars) {
            if (userId <= 0 || Number.isNaN(userId)) {
                return;
            }
            bridge.openPage('xiaochangmars://?ac=userinfo&uid=' + userId, closeBeforePage);
            return;
        }
        if (env.browser.isChangba) {
            if (cbUserId === 0 || cbUserId === 'false') {
                toast.show('该用户为火星直播用户，暂时未关联唱吧号');
                return;
            }
            if (cbUserId) {
                bridge.openPage('changba://?ac=personalpage&userid=' + cbUserId, closeBeforePage);
                return;
            }
        }
        // 跳转唱吧app
        var curl = 'changba://?ac=personalpage&userid=' + cbUserId;
        // 如果是火星活动，则打开的时候默认打开火星app
        var appType = typeof MARS !== 'undefined' ? 'mars' : 'cb';
        this.jumpToApp(curl, '', appType);
    };
    return Goto;
}());
export { Goto };
